import Label from 'LuxKit/Label/Label'
import LuxPlusLogo from 'luxPlus/components/Logos/LuxPlusLogo'
import { useAppSelector } from 'hooks/reduxHooks'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import React from 'react'
import { FormattedMessage } from 'react-intl'

const LOGO_HEIGHT = 10
const ELIGIBLE_REGIONS = new Set(['AU', 'NZ', 'US', 'SG'])

function TourLuxPlusCampaignTag() {
  const luxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)
  const regionCode = useAppSelector(state => state.geo.currentRegionCode)

  if (!luxPlusEnabled || !ELIGIBLE_REGIONS.has(regionCode)) return null

  return <Label kind="primary" variant="lux-plus" data-testid="tour-lux-plus-campaign-tag">
    <FormattedMessage
      id="YmMkePpC2P"
      defaultMessage="Unlock 5% Off with {logo}"
      description="Campaign urgency tag for LuxPlus+ members 5% off tour offers"
      values={{ logo: <LuxPlusLogo colour="inherit" height={LOGO_HEIGHT} /> }}
    />
  </Label>
}

export default TourLuxPlusCampaignTag
